<template>
    <div v-if="hasNextGroups || hasActiveGroup || hasOldGroups" class="actual-groups-of-one-type">
        <h5 v-text="courseType.name" class="actual-groups-header"></h5>
        <ul v-if="showNextGroups && hasNextGroups">
            <li v-for="nextGroup in nextGroups" :key="nextGroup.id">
                <a class="text-dark" @click="$emit('select-course-group', nextGroup)" href="javascript://">
                    <i class="fa fa-arrow-circle-o-up fa-lg text-secondary" aria-hidden="true"></i> {{ nextGroup.getDisplayDate() }}
                </a>
            </li>
        </ul>
        <ul v-if="hasActiveGroup">
            <li>
                <a class="text-dark" @click="$emit('select-course-group', activeGroup)" href="javascript://">
                    <i class="fa fa-arrow-circle-o-right fa-lg text-success" aria-hidden="true"></i> {{ activeGroup.getDisplayDate() }}
                </a>
            </li>
        </ul>
        <ul v-if="hasOldGroups">
            <li v-for="oldGroup in oldGroups" :key="oldGroup.id">
                <a class="text-dark" @click="$emit('select-course-group', oldGroup)" href="javascript://">
                    <i class="fa fa-arrow-circle-o-down fa-lg text-danger" aria-hidden="true"></i> {{ oldGroup.getDisplayDate() }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
const ActualGroupsOfOneTypeComponent = {
    props: {
        courseType: {
            type: Object,
            required: true
        },
        oldGroupsCount: {
            type: Number,
            default: 3
        },
        showNextGroups: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        courseTypeGroups() {
            return this.$store.state.courseGroups
                .filter(g => g.courseType === this.courseType.value)
                .sort((g1, g2) => (new Date(g2.startDate)).valueOf() - (new Date(g1.startDate).valueOf()));
        },

        oldGroups() {
            const oldGroups = this.courseTypeGroups.filter(g => (new Date(g.startDate)).valueOf() <= Date.now().valueOf());
            // Пропускаем самую первую (позднюю по дате) группу, т.к. ее считаем текущей
            return oldGroups.slice(1, this.oldGroupsCount + 1);
        },

        nextGroups() {
            return this.courseTypeGroups.filter(g => (new Date(g.startDate)).valueOf() > Date.now().valueOf());
        },

        hasNextGroups() {
            return this.nextGroups.length > 0;
        },

        activeGroup() {
            const activeGroup = this.courseTypeGroups.find(g => (new Date(g.startDate)).valueOf() <= Date.now().valueOf());
            return activeGroup !== undefined ? activeGroup : null;
        },

        hasActiveGroup() {
            return this.activeGroup !== null;
        },

        hasOldGroups() {
            return this.oldGroups.length > 0;
        }
    }
};

export default ActualGroupsOfOneTypeComponent;
</script>